import axios from 'axios'
import axiosWrapper from '@/utils/request'

const CancelToken = axios.CancelToken

let fetchCancellable = null
const fetch = (
  accountId,
  vars = {},
  page = 1,
  limit = 30,
  serializer = null
) => {
  if (fetchCancellable != null) {
    fetchCancellable.cancel()
  }
  fetchCancellable = CancelToken.source()
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/invoices_list`,
    params: {
      limit: limit,
      page: page,
      vars: vars,
      serializer: serializer
    },
    cancelToken: fetchCancellable.token
  })
}

const invoiceMeta = () => {
  return axiosWrapper({
    url: '/v1/business/invoices/meta'
  })
}

const validateToken = () => {
  return axiosWrapper({
    url: `/v1/business/invoices/meta?authenticate`
  })
}

const downloadInvoice = (invoiceId) => {
  return axiosWrapper({
    url: `/v1/business/invoices/${invoiceId}/call/invoice_copy/`,
    responseType: 'blob',
    method: 'POST',
    params: {
      vars: {
        filename: `invoices-${invoiceId}-advice`
      }
    }
  })
}

const getInvoiceCalculationDetails = (invoiceId) => {
  return axiosWrapper({
    url: `/v1/business/invoices/${invoiceId}/view/calculation_details`
  })
}

const getCalculationDetailsOnDate = (invoiceId, expectedDate) => {
  return axiosWrapper({
    url: `/v1/business/invoices/${invoiceId}/view/fee_calculation_breakup`,
    params: {
      vars: {
        as_on: expectedDate
      }
    }
  })
}

const fetchDocsAndAckSign = (params) => {
  return axiosWrapper({
    url: `/v1/business/invoices/call/generate_docs_and_ack_sign_url`,
    params
  })
}

const fetchDocsAndBoeSign = (params) => {
  return axiosWrapper({
    url: `/v1/business/invoices/call/generate_docs_and_boe_sign_url`,
    params
  })
}

const fetchAbodeSign = (params) => {
  return axiosWrapper({
    url: `/v1/business/invoices/call/generate_adobe_sign_url`,
    params
  })
}

const fetchInvoicesById = (invoiceId, params) => {
  return axiosWrapper({
    url: `/v1/business/invoices/${invoiceId}`,
    params
  })
}

const postInvoices = (data) => {
  return axiosWrapper({
    method: 'POST',
    url: '/v1/business/invoices',
    data
  })
}

const updateInvoices = (invoiceId, data) => {
  return axiosWrapper({
    method: 'PUT',
    url: `/v1/business/invoices/${invoiceId}`,
    data
  })
}
const modifyInvoices = (method, invoiceId, data) => {
  return axiosWrapper({
    method,
    url: `/v1/business/invoices/${invoiceId}`,
    data
  })
}
const getAllInvoicesByEndpoint = (accountId, endpoint, params) => {
  return axiosWrapper({
    url: `/v1/business/importers/${accountId}/view/${endpoint}`,
    params,
    timeout: 120000
  })
}
const getInvoicesByToken = (invoiceId, authToken, token) => {
  return axiosWrapper({
    url: `/v1/business/invoices/${invoiceId}/auth/${authToken}`,
    headers: {
      Authorization: 'Token ' + token
    }
  })
}
const getPdcDetails = (invoiceId, token) => {
  return axiosWrapper({
    url: `v1/business/invoices/${invoiceId}/call/pdc_calculator`,
    headers: {
      Authorization: 'Token ' + token
    }
  })
}
const getDiscrepantInvoices = (invoiceId, token) => {
  return axiosWrapper({
    url: `/v1/business/invoices/${invoiceId}/call/invoice_check_discrepancy`,
    headers: {
      Authorization: 'Token ' + token
    }
  })
}

const updateRemittanceStatus = (data) => {
  return axiosWrapper({
    method: 'POST',
    url: `/v1/drip_switch/status/create_or_update`,
    data
  })
}

const fetchDripSwitchStatus = () => {
  return axiosWrapper({
    method: 'GET',
    url: `/switch/v1/status`
  })
}

const downloadSwiftCopy = (madeFor = 'invoices', invId, type) => {
  return axiosWrapper({
    method: 'GET',
    url: `/v2/business/${madeFor}/${invId}/swift-copy${
      type ? '?type=' + type : ''
    }`,
    responseType: 'blob'
  })
}

const downloadNocCopy = (
  madeFor = 'invoices',
  invId,
  type,
  timeout = 300000
) => {
  return axiosWrapper({
    method: 'GET',
    url: `/v2/business/${madeFor}/${invId}/noc-copy${
      type ? '?type=' + type : ''
    }`,
    responseType: 'blob',
    timeout: timeout
  })
}

const checkSwiftCopy = (madeFor = 'invoices', ids) => {
  if (madeFor === 'invoices') {
    return axiosWrapper({
      method: 'GET',
      url: `/v2/business/${madeFor}/check-swift-copies`,
      params: {
        invoice_ids: ids
      }
    })
  }
  return axiosWrapper({
    method: 'GET',
    url: `/v2/business/${madeFor}/check-swift-copies`,
    params: {
      advance_ids: ids
    }
  })
}

const checkNocCopy = (madeFor = 'invoices', ids) => {
  if (madeFor === 'invoices') {
    return axiosWrapper({
      method: 'GET',
      url: `/v2/business/${madeFor}/check-noc-copies`,
      params: {
        invoice_ids: ids
      }
    })
  }
  return axiosWrapper({
    method: 'GET',
    url: `/v2/business/${madeFor}/check-noc-copies`,
    params: {
      advance_ids: ids
    }
  })
}

const removeInvoiceDocument = (invoiceId, documentId) => {
  return axiosWrapper({
    method: 'DELETE',
    url: `/v2/business/invoices/${invoiceId}/documents/${documentId}`
  })
}

export default {
  fetch,
  downloadInvoice,
  getInvoiceCalculationDetails,
  getCalculationDetailsOnDate,
  fetchDocsAndAckSign,
  fetchDocsAndBoeSign,
  fetchAbodeSign,
  fetchInvoicesById,
  postInvoices,
  updateInvoices,
  modifyInvoices,
  invoiceMeta,
  getAllInvoicesByEndpoint,
  getInvoicesByToken,
  getPdcDetails,
  getDiscrepantInvoices,
  updateRemittanceStatus,
  fetchDripSwitchStatus,
  downloadSwiftCopy,
  checkSwiftCopy,
  removeInvoiceDocument,
  validateToken,
  downloadNocCopy,
  checkNocCopy
}
